
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/jwt-debugger",
      function () {
        return require("private-next-pages/tools/jwt-debugger.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/jwt-debugger"])
      });
    }
  